// removed by extract-text-webpack-plugin
module.exports = {"component":"Image__component___3lgAP","zoomIcon":"Image__zoomIcon___xITgt"};


//////////////////
// WEBPACK FOOTER
// ./src/homepage/components/Image.css
// module id = 416
// module chunks = 0